module.exports = __webpack_public_path__ + "images/slide_down_close_box.gif";